import { Outlet, useNavigate } from 'react-router-dom'

import useUserAccess from '~/features/auth/hooks/useUserAccess'
import { EClientPath } from '~/models/api'

function PlusRestrictedRoute() {
  const navigate = useNavigate()
  const { isPlusUser } = useUserAccess()

  if (!isPlusUser) {
    navigate(EClientPath.billing, { replace: true })
    return null
  }

  return <Outlet />
}

export default PlusRestrictedRoute
